// eslint-disable-next-line import/prefer-default-export
export const getAppUrl = (path: string = '') => `https://${window.location.hostname}/${path.replace(/^\//, '')}`;
